// extracted by mini-css-extract-plugin
module.exports = {"sliderDays":"PricesPageSliderWrapper_sliderDays__3BGup","sliderWrapper":"PricesPageSliderWrapper_sliderWrapper__1msM7"};